import React from 'react';
import PropTypes from 'prop-types';

import FooterUpsell from 'components/FooterUpsell';
import MapElevationChartWrapper from '../MapElevationChartWrapper';
import AthleteBanner from './components/AthleteBanner';
import Comments from './components/Comments';
import Summary from './components/Summary';
import MoreActivities from './components/MoreActivities';
import Photos from './components/Photos';
import Upsell from './components/Upsell';

import styles from './styles.scss';

function ActivityPublic({ activity, photos, analyticsData }) {
  const { streams } = activity;

  return (
    <main role="main">
      <AthleteBanner {...activity.athlete} analyticsData={analyticsData} />
      <div className="container">
        <div className={`row ${styles.row}`}>
          <div className={`col-md-6 ${styles.mapData}`}>
            {activity.map.present && streams && (
              <MapElevationChartWrapper streams={streams} />
            )}
          </div>
          <div className={`col-md-6 ${styles.activityData}`}>
            <Summary {...activity} />
            <Photos photos={photos} analyticsData={analyticsData} />
            <Comments
              comments={activity.comments}
              activityCommentUrl={activity.authUrls.activityComment}
              analyticsData={analyticsData}
            />
            <Upsell type={activity.type} analyticsData={analyticsData} />
          </div>
        </div>
      </div>

      <MoreActivities
        activities={activity.relatedActivities}
        athlete={activity.athlete}
        analyticsData={analyticsData}
      />
      <FooterUpsell
        authUrls={activity.authUrls}
        athlete={activity.athlete}
        analyticsData={analyticsData}
      />
    </main>
  );
}

ActivityPublic.defaultProps = {
  photos: []
};

ActivityPublic.propTypes = {
  activity: PropTypes.shape({
    type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    streams: PropTypes.object.isRequired,
    authUrls: PropTypes.object.isRequired,
    map: PropTypes.shape({
      present: PropTypes.any.isRequired,
      src: PropTypes.object.isRequired
    }),
    athlete: PropTypes.shape({}).isRequired,
    relatedActivities: PropTypes.array.isRequired,
    comments: PropTypes.array.isRequired
  }).isRequired,
  photos: PropTypes.arrayOf(PropTypes.object),
  analyticsData: PropTypes.shape().isRequired
};

export default ActivityPublic;
